<template>
  <PageTemplate
    :useCard="false"
    :breadcrumbs="[
      {
        text: `RDE ${$t('workspace_rde.catalog.title')}`,
      },
    ]"
    padding="p-3"
  >
    <Card :usePadding="false">
      <Tabs v-model="tabIndex">
        <template #tabs>
          <Tab>{{ $t("workspace.base.label.image") }}</Tab>
          <Tab>{{ $t("workspace.base.label.imageGroup") }}</Tab>
          <Tab>{{ $t("workspace.base.label.extensionPackage") }}</Tab>
          <Tab>{{ $t("workspace.base.label.extensions") }}</Tab>
        </template>
        <template #items>
          <TabItem><ImageTab /></TabItem>
          <TabItem><ImageGroupTab /></TabItem>
          <TabItem> <ExtensionPackageTab /> </TabItem>
          <TabItem> <ExtensionsTab /> </TabItem>
        </template>
      </Tabs>
    </Card>
  </PageTemplate>
</template>

<script>
import ExtensionPackageTab from "./subtabs/ExtensionPackage/ExtensionPackageTab.vue";
import ExtensionsTab from "./subtabs/Extensions/ExtensionsTab.vue";
import ImageTab from "./subtabs/Image/ImageTab.vue";
import ImageGroupTab from "./subtabs/ImageGroup/ImageGroupTab.vue";

export default {
  components: { ImageTab, ImageGroupTab, ExtensionPackageTab, ExtensionsTab },
  data: () => ({ tabIndex: 0 }),
};
</script>

<style lang="scss"></style>
